<template>
  <v-app id="app">
    <v-card class="overflow-hidden">
      <v-app-bar
        absolute
        color="#6A76AB"
        dark
        shrink-on-scroll
        prominent
        src="https://shootest.jp/wp-content/uploads/2020/06/shibuya-gallery-1-786x530.jpg"
        fade-img-on-scroll
        scroll-target="#scrolling-techniques-3"
      >
        <template v-slot:img="{ props }">
          <v-img
            v-bind="props"
            gradient="to top right, rgba(100,115,201,.7), rgba(25,32,72,.7)"
          ></v-img>
        </template>

        <!-- <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon> -->

        <v-toolbar-title>在庫管理表</v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- <template v-slot:extension>
          <v-tabs align-with-title>
            <v-tab>レディース</v-tab>
            <v-tab>メンズ</v-tab>
            <v-tab>ユニセックス</v-tab>
          </v-tabs>
        </template> -->
      </v-app-bar>
      <v-sheet
        id="scrolling-techniques-3"
        class="overflow-y-auto"
        max-height="600"
      >
        <v-container style="height: 227px;"></v-container>
      </v-sheet>
    </v-card>

    <v-layout row xs4 v-for="(stock, index) in stocks" :key="index">
      <v-container>
        <v-flex xs12 sm6 offset-sm3>
          <v-card class="mt-4 mb-4 pa-3">
            <v-img
              src="https://img.alicdn.com/imgextra/i1/793128737/O1CN017nsqIs2EPb3AQF8FE_!!793128737.jpg_q90.jpg"
              height="400px"
            >
            </v-img>

            <v-card-title primary-titlen>
              <div>
                <p>商品名：{{ stock.stock_name }}</p>
                <p>値段：{{ stock.stock_price }}円</p>
                <p>在庫数：{{ stock.stock }}着</p>

                <!-- <v-btn @click="deleteItem(index)" color="red">削除</v-btn> -->

                <!-- <v-btn @click="editStock(stock)" color="orange">編集</v-btn> -->
              </div>
            </v-card-title>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn icon @click="show = !show">
                <v-icon>{{ show ? "🔽" : "🔼" }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-slide-y-transition>
              <v-card-text v-show="show">
                説明文：{{ stock.stock_text }}
              </v-card-text>
            </v-slide-y-transition>
          </v-card>
        </v-flex>
      </v-container>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on" @click="createStock()"
            >新規在庫追加</v-btn
          >
        </template>

        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title v-if="createFlag"
              >新規在庫追加ページ</v-toolbar-title
            >

            <v-toolbar-title v-else>商品編集ページ</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-toolbar-items>
              <v-btn @click="dialog = false" color="info">閉じる</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-list three-line subheader>
            <v-subheader>Stock Controls</v-subheader>
            <!-- <v-list-tile avatar> -->
            <v-card class="e4">
              <v-form>
                <v-row style="height: 800px;">
                  <v-container>
                    <v-text-field
                      v-model="stockAdd.stock_name"
                      label="商品名"
                    ></v-text-field>

                    <v-col cols="12">
                      <v-slider
                        v-model="stockAdd.stock"
                        :max="300"
                        label="商品在庫数"
                        class="align-center"
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="stockAdd.stock"
                            :max="300"
                            class="mt-0 pt-0"
                            type="number"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                    <!-- <v-text-field
                      v-model="stockAdd.stock"
                      label="商品在庫数"
                    ></v-text-field> -->
                    <v-col cols="12">
                      <v-slider
                        v-model="stockAdd.stock_price"
                        :max="9999"
                        label="商品価格"
                        class="align-center"
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="stockAdd.stock_price"
                            :max="9999"
                            class="mt-0 pt-0"
                            type="number"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>

                    <!-- <v-text-field
                      v-model="stockAdd.stock_price"
                      label="商品価格"
                    ></v-text-field> -->

                    <v-text-field
                      v-model="stockAdd.stock_text"
                      label="商品説明文"
                    ></v-text-field>

                    <v-btn
                      @click="registationStock"
                      color="info"
                      v-if="createFlag"
                      >登録</v-btn
                    >
                    <v-btn @click="updateStock" color="info" v-else>更新</v-btn>
                  </v-container>
                </v-row>
              </v-form>
            </v-card>
            <!-- </v-list-tile> -->
          </v-list>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-app>
</template>

<script>
import axios from "axios"
export default {
  data: function() {
    return {
      message: "Hello Vue!",
      stocks: [],
      stock: {},
      // stockForm: {
      //   stock_name: "",
      //   stock: 0,
      // },
      stockAdd: {
        stock_id: 0,
        stock_name: "",
        stock_price: 0,
        stock: 0,
        stock_text: ""
      },
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      editIndex: -1,
      createFlag: true,
      stock_price: 0
    }
  },
  methods: {
    registationStock() {
      if (
        this.stockAdd.stock > 0 &&
        this.stockAdd.stock_name &&
        this.stockAdd.stock_price > 0
      ) {
        axios
          .post(`${process.env.VUE_APP_API_BASE_URL}/api/v1/stocks/create`, {
            stock: this.stockAdd
          })
          .then((rseponse) => {
            this.stocks.push(rseponse.data)
            this.dialog = false
          })
          .catch((error) => console.log(error))
      } else {
        alert("正しく入力して下さい")
        this.dialog = true
      }
      // this.createFlag = true;
      // this.stockAdd();
    },
    // getStock(id) {
    //   axios
    //     .get(`http://localhost:3000/api/v1/stocks/${id}`)
    //     .then((response) => {
    //       this.stock = response.data
    //     })
    //     .catch((error) => console.log(error))
    // },
    getStockAll() {
      axios
        .get(`${process.env.VUE_APP_API_BASE_URL}/api/v1/stocks`)
        .then((response) => {
          this.stocks = response.data
        })
        .catch((error) => console.log(error))
    },
    deleteItem: function(index) {
      this.stocks.splice(index, 1)
    },
    createStock() {
      this.createFlag = true
      this.stockAdd = {
        stock_name: "",
        stock_price: 0,
        stock: 0,
        stock_text: ""
      }
      this.dialog = true
    },
    editStock(stock) {
      this.createFlag = false
      this.stockAdd = {
        stock_id: stock.id,
        stock_name: stock.stock_name,
        stock_price: stock.stock_price,
        stock: stock.stock,
        stock_text: stock.stock_text
      }
      this.dialog = true
    },
    updateStock() {
      // Object.assign(this.stocks[this.editIndex], this.stockAdd);
      let result = this.stocks.find((v) => v.id === this.stockAdd.stock_id)
      console.log(result)
      result.stock_id = this.stockAdd.id
      result.stock_name = this.stockAdd.stock_name
      result.stock_price = this.stockAdd.stock_price
      result.stock = this.stockAdd.stock
      result.stock_text = this.stockAdd.stock_text
      this.dialog = false
    }
  },
  created() {
    this.getStockAll()
  }
}
</script>

<style scoped>
.e4 {
  width: 100%;
  margin: auto;
}
</style>
